import React, { useCallback, useEffect, useState } from 'react';

import Button, { LoadingButton } from '@atlaskit/button';

import integration from 'src/lib/api/integration';
import jira from 'src/lib/api/jira';
import { getQueryParams } from 'src/lib/history';

import CenteredSpinner from 'src/views/components/CenteredSpinner';
import ErrorMessage from 'src/views/components/ErrorMessage';
import ModalButtons from 'src/views/components/ModalButtons';
import ModalContainer from 'src/views/components/ModalContainer';
import UserMappingSummary from 'src/views/components/UserMappingSummary';

const ConfirmationDialog = ({ userMappingId }) => {
  const [{ loading, error, userMapping }, setMapping] = useState({ loading: true });
  const [{ submitLoading, submitError }, setSubmitStatus] = useState({});

  useEffect(() => {
    setMapping({ loading: true });
    integration.getUserMapping(userMappingId)
      .then(userMapping => setMapping({ userMapping }))
      .catch(error => setMapping({ error }));
  }, [userMappingId]);

  const removeUserMapping = useCallback(() => {
    setSubmitStatus({ submitLoading: true });
    integration.removeUserMapping(userMappingId)
      .then(() => jira.closeCurrentModal())
      .catch(submitError => setSubmitStatus({ submitError }));
  }, [userMappingId]);

  return (
    <div>
      <div style={{ minHeight: 250 }}>
        {loading && <CenteredSpinner size="large"/>}
        {error && <ErrorMessage error={['Failed to load user mapping', error || 'Unknown error']}/>}
        {userMapping && <UserMappingSummary userMapping={userMapping}/>}
      </div>
      {submitError && <ErrorMessage error={['Can not remove user mapping', submitError]}/>}
      <ModalButtons>
        <Button onClick={e => jira.closeCurrentModal()}>Cancel</Button>
        <LoadingButton appearance="danger" onClick={removeUserMapping} isDisabled={!userMapping} isLoading={submitLoading}>Remove</LoadingButton>
      </ModalButtons>
    </div>
  );
};

const RemoveUsersMapping = () => {
  const { userMappingId } = getQueryParams();
  return (
    <ModalContainer title="Please confirm mapping removal for user">
      <ConfirmationDialog userMappingId={userMappingId}/>
    </ModalContainer>
  );
};

export default RemoveUsersMapping;
